import { module } from 'modujs';
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$container = this.$('container')[0]
    }

    //////////////
    // Lifecycle
    //////////////
    init() {
        Swiper.use([Autoplay, EffectFade])

        const args = {
            simulateTouch: false,
            autoplay: {
                delay: 1500
            },
            effect: 'fade',
            speed: 700,
            loop: true,
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
                prevEl: this.$prevButton,
                nextEl: this.$nextButton,
            }
        }

        this.carousel = new Swiper(this.$container, args)
        this.carousel.autoplay.pause()
    }

    ///////////////
    // Callbacks
    ///////////////
    onInview(args) {
        if (args.way === 'enter') {
            this.carousel.autoplay.resume()
        } else if (args.way === 'leave') {
            this.carousel.autoplay.pause()
        }
    }

    destroy() {
        super.destroy()
        this.carousel?.destroy(true, true)
    }
}
